import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type StatementItem } from '@webapp/modules/accounts-payable/entities/StatementItem'
import messages from './messages'
import { useMutateCreateStatementItem } from '../../models'
import { type StatementItemFormSchema } from '../../views/StatementItemForm'

export interface IUseCreateStatementItemFormPresenterParams {
  accountId: number
  /** FS unshifts the created row with "JUST CREATED" (BHV-041) */
  onCreated: (item: StatementItem) => void
}

export const useCreateStatementItemFormPresenter = ({
  accountId,
  onCreated,
}: IUseCreateStatementItemFormPresenterParams) => {
  const intl = useProcurifyIntl()
  const { createStatementItem, isCreating } = useMutateCreateStatementItem()

  // No success toast — the list updates in place (BHV-041).
  const onSubmit = async (values: StatementItemFormSchema) => {
    try {
      const created = await createStatementItem({
        creditcardId: accountId,
        description: values.description,
        // Validation guarantees a date; submit as YYYY-MM-DD (BHV-041)
        date: values.date ? values.date.format('YYYY-MM-DD') : '',
        amount: parseFloat(values.amount).toFixed(2),
      })

      onCreated(created)
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
    }
  }

  return {
    states: {
      isCreating,
    },
    methods: {
      onSubmit,
    },
  }
}
